<template>
    <div class = 'grid'>
        <Row>
            <Col style = 'min-height:1px;' :key = 'index' v-for = '(item,index) in gridConf.Parameter.colList' :span="item.colSpan">
                <component v-if = 'item.children.length' :is = 'getComponent(item.children[0])' :conf = 'conf' />
            </Col>
        </Row>
    </div>
</template>
<script>
import mixComponent from './mixComponent.vue';
export default {
    data(){
        return {}
    },
    computed: {
    },
    mounted() {
    },
    methods:{
        getComponent(conf){
            if(!conf){
                return;
            }
            if(conf.componentType == 'publicComponent'){
              return this.$store.state.dynamicComponent.DIYLAYOUT[conf.componentCode]
            }else{
              return mixComponent;
            }
        }
    },
    props: {
        gridConf: Object
    },
    components: {}
}
</script>
<style scoped lang = 'less'>
.grid{
    margin:10px 0;
    padding:20px;
    border-radius:3px;
    border:1px solid #ccc;
    background:#fff;
}
</style>